module.exports = __webpack_public_path__ + "img/731.9cfaa65c.jpg";